var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38651 23.8566H0.159424V14.6215H9.39448L9.38651 23.8566Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24H9.51394V14.6135H0V24Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2988 4.96414V19.0359H17.3625C16.5259 12.0797 12.0876 7.70518 5.02789 6.87649V4.96414H19.2988ZM0 0V11.6813H2.51793C9.13147 11.6813 12.494 14.988 12.494 21.5219V24H24.3267V0H0Z",
    fill: "#1CBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3267,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay5);
export default __webpack_public_path__ + "static/media/pay5.923573f1090bff311adc38720601df05.svg";
export { ForwardRef as ReactComponent };